// Copyright (c) 2017 Deere & Company

export default Object.freeze({
    RESET_ADVANCED_CLAIM_SUMMARY_CLAIM_STATUSES: 'RESET_ADVANCED_CLAIM_SUMMARY_CLAIM_STATUSES',
    RESET_ADVANCED_CLAIM_SUMMARY_CRITERIA: 'RESET_ADVANCED_CLAIM_SUMMARY_CRITERIA',
    RESET_ADVANCED_CLAIM_SUMMARY_DEALERS: 'RESET_ADVANCED_CLAIM_SUMMARY_DEALERS',
    RESET_ADVANCED_CLAIM_SUMMARY_IS_PRINT_CLAIM_DISABLED: 'RESET_ADVANCED_CLAIM_SUMMARY_IS_PRINT_CLAIM_DISABLED',
    RESET_ADVANCED_CLAIM_SUMMARY_REPORT: 'RESET_ADVANCED_CLAIM_SUMMARY_REPORT',
    RESET_ADVANCED_CLAIM_SUMMARY_REPORT_IS_SCROLLABLE: 'RESET_ADVANCED_CLAIM_SUMMARY_REPORT_IS_SCROLLABLE',
    RESET_ADVANCED_CLAIM_SUMMARY_SHOW_SELECT_ALL: 'RESET_ADVANCED_CLAIM_SUMMARY_SHOW_SELECT_ALL',
    SELECT_ADVANCED_CLAIM_SUMMARY_CLAIM_STATUS: 'SELECT_ADVANCED_CLAIM_SUMMARY_CLAIM_STATUS',
    SELECT_ADVANCED_CLAIM_SUMMARY_DEALER: 'SELECT_ADVANCED_CLAIM_SUMMARY_DEALER',
    SELECT_ALL_ADVANCED_CLAIM_SUMMARY_CLAIM_STATUSES: 'SELECT_ALL_ADVANCED_CLAIM_SUMMARY_CLAIM_STATUSES',
    SELECT_ALL_ADVANCED_CLAIM_SUMMARY_CLAIM_STATUSES_ON_LOAD: 'SELECT_ALL_ADVANCED_CLAIM_SUMMARY_CLAIM_STATUSES_ON_LOAD',
    SELECT_ALL_ADVANCED_CLAIM_SUMMARY_DEALERS: 'SELECT_ALL_ADVANCED_CLAIM_SUMMARY_DEALERS',
    SELECT_ALL_ADVANCED_CLAIM_SUMMARY_DEALERS_ON_LOAD: 'SELECT_ALL_ADVANCED_CLAIM_SUMMARY_DEALERS_ON_LOAD',
    TOGGLE_ADVANCED_CLAIM_SUMMARY_REPORT_IS_SCROLLABLE: 'TOGGLE_ADVANCED_CLAIM_SUMMARY_REPORT_IS_SCROLLABLE',
    UPDATE_ADVANCED_CLAIM_SUMMARY_CLAIM_CREATED_DATE: 'UPDATE_ADVANCED_CLAIM_SUMMARY_CLAIM_CREATED_DATE',
    UPDATE_ADVANCED_CLAIM_SUMMARY_CRITERION: 'UPDATE_ADVANCED_CLAIM_SUMMARY_CRITERION',
    UPDATE_ADVANCED_CLAIM_SUMMARY_IS_PRINT_CLAIM_DISABLED: 'UPDATE_ADVANCED_CLAIM_SUMMARY_IS_PRINT_CLAIM_DISABLED',
    UPDATE_ADVANCED_CLAIM_SUMMARY_REPORT: 'UPDATE_ADVANCED_CLAIM_SUMMARY_REPORT',
    UPDATE_ADVANCED_CLAIM_SUMMARY_SHOW_SELECT_ALL: 'UPDATE_ADVANCED_CLAIM_SUMMARY_SHOW_SELECT_ALL'
});



// WEBPACK FOOTER //
// ./src/reports/advanced-claim-summary/actions-list.js